
// Main export file for the armpit rash and itching article data
import { armpitRashItchyMetadata } from './metadata';
import { armpitRashItchyContent } from './content';
import { armpitRashItchySources } from './sources';
import { armpitRashItchyRecommendedProducts } from './recommended-products';
import { armpitRashItchyRelatedArticles } from './related-articles';

export const armpitRashItchyArticle = {
  ...armpitRashItchyMetadata,
  content: armpitRashItchyContent,
  sources: armpitRashItchySources,
  recommendedProducts: armpitRashItchyRecommendedProducts,
  relatedArticles: armpitRashItchyRelatedArticles
};
